import React from 'react';

import PrivatePage from 'components/PrivatePage';
import Results from 'components/Results';
import Spinner from 'components/Spinner';
import useResults from 'hooks/useResults';

const Stats = ({navbarProps}) => {
  const {results, isLoading} = useResults();
  return (
    <PrivatePage navbarProps={navbarProps}>
      <div className="container">
        <h1 className="title is-1">
          Statistiques
        </h1>
        {isLoading ?
          <Spinner size="3x" />
        :
          <Results series={results} />
        }
      </div>
    </PrivatePage>
  )
}

export default Stats;